import React from 'react';
import { megaMenuProductsPropTypes } from './MegaMenuProductsPropTypes';
import RatingStars from '@Theme/natucare/components/RatingStars/RatingStars';
import Picture from '@Theme/natucare/components/Picture/Picture';
import * as styles from './MegaMenuProducts.module.scss';
const MegaMenuProducts = ({
  items
}) => {
  if (!items) {
    return null;
  }
  const handleStopPropagation = e => {
    // In order to avoid closing navItem menu while clicking nested navItem elements
    e.stopPropagation();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root,
    onClick: handleStopPropagation
  }, items.map((item, index) => {
    var _item$picture, _item$picture2, _item$price, _item$price2, _item$price3, _item$price4;
    const pictureData = {
      xs: {
        src: (_item$picture = item.picture) === null || _item$picture === void 0 ? void 0 : _item$picture.src
      },
      alt: (_item$picture2 = item.picture) === null || _item$picture2 === void 0 ? void 0 : _item$picture2.alt
    };
    return /*#__PURE__*/React.createElement("a", {
      href: item.href,
      className: styles.rootTileLink,
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.rootPictureWrapper
    }, /*#__PURE__*/React.createElement(Picture, Object.assign({}, pictureData, {
      pictureClassname: styles.rootPicture,
      imgClassname: styles.rootImage
    })), item.labels && /*#__PURE__*/React.createElement("div", {
      className: styles.rootPictureLabelWrapper
    }, item.labels.map((label, labelIndex) => /*#__PURE__*/React.createElement("span", {
      className: styles.rootPictureLabel,
      key: labelIndex
    }, label)))), /*#__PURE__*/React.createElement("div", {
      className: styles.rootProduct
    }, (item === null || item === void 0 ? void 0 : item.rating) && /*#__PURE__*/React.createElement(RatingStars, item.rating), /*#__PURE__*/React.createElement("span", {
      className: styles.rootProductTitle
    }, item.title), ((_item$price = item.price) === null || _item$price === void 0 ? void 0 : _item$price.regular) && /*#__PURE__*/React.createElement("div", {
      className: styles.rootProductPriceWrapper
    }, ((_item$price2 = item.price) === null || _item$price2 === void 0 ? void 0 : _item$price2.sale) && ((_item$price3 = item.price) === null || _item$price3 === void 0 ? void 0 : _item$price3.regular) > ((_item$price4 = item.price) === null || _item$price4 === void 0 ? void 0 : _item$price4.sale) && /*#__PURE__*/React.createElement("span", {
      className: `${styles.rootProductPrice} ${styles.rootProductPriceSale}`
    }, item.price.sale.toFixed(2), " ", item.price.currency), /*#__PURE__*/React.createElement("span", {
      className: `${styles.rootProductPrice} ${styles.rootProductPriceRegular}`
    }, item.price.regular.toFixed(2), " ", item.price.currency))));
  }));
};
export default MegaMenuProducts;